import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from './Components/Home';
import Notfound from './Components/NotFound';

class Main extends Component {
  render() {
    return (
        <div className="App-main">
            <Switch>
                <Route path='/' component={Home}/>
                <Route component={Notfound} />
            </Switch>
        </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.jsx